







import { defineComponent } from '@vue/composition-api';

import SelectSpacePath from '@/renderer/components/dialog/SelectFilePath/components/SelectSpacePath.vue';
import SelectStencilPath from '@/renderer/components/dialog/SelectFilePath/components/SelectStencilPath.vue';

export default defineComponent({
  components: {
    SelectSpacePath,
    SelectStencilPath,
  },
  props: {
    // type-- 文件空间路径file | 表示选择模板库stencil
    type: {
      required: false,
      type: String,
      default: 'file',
    },
  },
});
